import { render, staticRenderFns } from "./release-task-detail.vue?vue&type=template&id=12c1873e&scoped=true&"
import script from "./release-task-detail.vue?vue&type=script&lang=js&"
export * from "./release-task-detail.vue?vue&type=script&lang=js&"
import style0 from "./release-task-detail.vue?vue&type=style&index=0&id=12c1873e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c1873e",
  null
  
)

export default component.exports